import { string } from 'prop-types'
import { connect } from 'react-redux'
import { assetProxyImageUrl } from '@opallabs/routing'
import { actions, jsonApiWrapper } from '@opallabs/wormhole'
import HoverableSlideThumbnailHOC from './HoverableSlideThumbnail'
import ImageSlideThumbnail from './ImageSlideThumbnail'
import TextImageSlideThumbnail from './TextImageSlideThumbnail'
import TextSlideThumbnail from './TextSlideThumbnail'

const ConnectedHoverableSlideThumbnailHOC = (props) => {
  const { layout } = props
  let HoverableSlide
  switch (layout) {
    case 'section_header':
    case 'basic_text':
      HoverableSlide = HoverableSlideThumbnailHOC(TextSlideThumbnail)
      break
    case 'image_only':
      HoverableSlide = HoverableSlideThumbnailHOC(ImageSlideThumbnail)
      break
    case 'text_and_image':
      HoverableSlide = HoverableSlideThumbnailHOC(TextImageSlideThumbnail)
      break
    default:
      break
  }

  HoverableSlide({ ...props })
  return <HoverableSlide {...props} />
}

ConnectedHoverableSlideThumbnailHOC.propTypes = {
  layout: string,
}

const mapStateToProps = (state, props) => {
  let additionalProps

  if (state.jsonApiEntities && state.jsonApiEntities.slide) {
    const slide = state.jsonApiEntities.slide[props.slideId]
    const { canvas_asset_reference, background_asset_reference } =
      jsonApiWrapper({ data: slide, state }) || {}
    let backgroundImageUrl

    if (background_asset_reference && background_asset_reference.uuid) {
      backgroundImageUrl = assetProxyImageUrl({
        uuid: background_asset_reference.uuid,
      })
    }

    additionalProps = {
      ...slide,
      assetReference: canvas_asset_reference || props.assetReference,
      backgroundImageURL: backgroundImageUrl || props.backgroundImageURL || '',
    }
  }

  return additionalProps || {}
}

const mapDispatchToProps = (dispatch) => ({
  destroySlide: (presentationId, slideId) => {
    dispatch(actions.destroySlide(presentationId, slideId))
  },
  updateSlide: (presentationId, slideId, changes) => {
    dispatch(actions.updateSlide(presentationId, slideId, changes))
  },
})

const ConnectedHoverableSlideThumbnail = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedHoverableSlideThumbnailHOC)

export default ConnectedHoverableSlideThumbnail
